module.exports = __webpack_public_path__ + "img/75.5e1ef26f.png";